import { StyledTypographyProps } from 'common/types/typography.types';
import { MediaBreakpoints } from 'common/utils/helpers/theme.helpers';
import styled from 'styled-components';

export const StyledTypography = styled.div<StyledTypographyProps>`
  color: ${({ color, theme }) => (color ? color : theme.palette.light.N900)} !important;
  font-size: ${(style) => style.desktop.fontSize};
  font-weight: ${(style) => style.desktop.fontWeight};
  line-height: ${(style) => style.desktop.lineHeight};
  letter-spacing: ${(style) => style.desktop.letterSpacing};
  ${MediaBreakpoints.down('md')} {
    font-size: ${(style) => style.mobile?.fontSize};
    line-height: ${(style) => style.mobile?.lineHeight};
  }
`;
